import { Drawer, ListItemButton, ListItemIcon } from '@mui/material'
import { styled } from '@mui/material/styles'

interface SidebarDrawerProps {
  $width: number
}

interface NavigationIconProps {
  $collapsed?: boolean
  $nested?: boolean
}

export const SidebarDrawer = styled(Drawer, {
  shouldForwardProp: property => property !== '$width',
})<SidebarDrawerProps>(({ theme, $width }) => ({
  '& .MuiDrawer-paper': {
    top: 72,
    width: $width,
    height: 'calc(100% - 72px)',
    borderRight: `1px solid ${theme.navigation.border}`,
    backgroundColor: theme.palette.common.white,
    boxSizing: 'border-box',
    transition: theme.transitions.create('width', {
      duration: 350,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
}))

export const NavigationItemButton = styled(ListItemButton)(({ theme }) => ({
  minHeight: 50,
  paddingInline: theme.spacing(4),
  color: theme.navigation.text,
  '& .MuiListItemText-primary': {
    fontSize: 16,
    fontWeight: 400,
    whiteSpace: 'nowrap',
  },
  '&.Mui-selected': {
    marginInline: theme.spacing(1),
    paddingInline: theme.spacing(3),
    borderRadius: theme.shape.borderRadius * 2,
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.common.white,
    '& .MuiListItemText-primary': { fontWeight: 600 },
    '&:hover': { backgroundColor: theme.palette.primary.dark },
  },
  '&:hover': { backgroundColor: theme.navigation.hover },
  '&[data-collapsed="true"]': {
    marginInline: theme.spacing(1),
    paddingInline: 0,
    justifyContent: 'center',
  },
  '&[data-nested="true"]': {
    minHeight: 42,
    paddingLeft: theme.spacing(7),
    paddingRight: theme.spacing(4),
    color: theme.navigation.textMuted,
    '& .MuiListItemText-primary': { fontSize: 14 },
    '&.Mui-selected': {
      marginInline: 0,
      paddingLeft: theme.spacing(7),
      paddingRight: theme.spacing(4),
      borderRadius: 0,
      backgroundColor: theme.navigation.nestedSelected,
      color: theme.palette.primary.main,
      '&:hover': { backgroundColor: theme.navigation.nestedSelected },
    },
  },
})) as typeof ListItemButton

export const NavigationItemIcon = styled(ListItemIcon, {
  shouldForwardProp: property =>
    property !== '$collapsed' && property !== '$nested',
})<NavigationIconProps>(({ theme, $collapsed = false, $nested = false }) => ({
  minWidth: $nested ? 28 : 0,
  marginRight: $collapsed || $nested ? 0 : theme.spacing(1.5),
  color: 'inherit',
}))
